module.exports = __webpack_public_path__ + "static/SC-2f3a8e0b6feea8e0d3f2d2de2a5b3e5c.svg";